<div class="min-h-screen bg-gray-100">
  <!-- Header -->
  <header class="bg-white shadow">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
      <div class="flex justify-between items-center">
        <div>
          <h1 class="text-2xl font-bold text-gray-900">Admin Dashboard</h1>
          @if (authService.currentUser()) {
            <p class="text-sm text-gray-600 mt-1">
              Angemeldet als: <span class="font-medium">{{ authService.currentUser().username }}</span>
            </p>
          }
        </div>
        <div class="flex gap-4">
          <a
            routerLink="/"
            class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
          >
            Zur Webseite
          </a>
          <button
            (click)="onLogout()"
            class="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700"
          >
            Abmelden
          </button>
        </div>
      </div>
    </div>
  </header>

  <!-- Tabs -->
  <div class="bg-white border-b border-gray-200">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <nav class="flex space-x-8" aria-label="Tabs">
        <button
          (click)="setActiveTab('news')"
          [class]="activeTab() === 'news'
            ? 'border-blue-500 text-blue-600'
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
          class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm"
        >
          Nachrichten verwalten
        </button>
        <button
          (click)="setActiveTab('files')"
          [class]="activeTab() === 'files'
            ? 'border-blue-500 text-blue-600'
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
          class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm"
        >
          Dateien hochladen
        </button>
      </nav>
    </div>
  </div>

  <!-- Main Content -->
  <main class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
    @if (activeTab() === 'news') {
      <app-news-manager></app-news-manager>
    } @else if (activeTab() === 'files') {
      <app-file-upload></app-file-upload>
    }
  </main>
</div>
